<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <ngx-spinner bdColor="rgba(0,0,0, 0.4)">
    <ng-lottie [options]="options"></ng-lottie>
  </ngx-spinner>
</ion-app>